import { Injectable } from '@angular/core';
import * as XSS from 'xss';
import { ContentWysiwygService } from '../content-wysiwyg.service';

var html2json = require('html2json').html2json;
var json2html = require('html2json').json2html;

@Injectable({
  providedIn: 'root',
})
export class WysiwigService {
  constructor(private readonly contentWysiwygService: ContentWysiwygService) {}

  getSafeValue(value) {
    const whiteList = XSS.getDefaultWhiteList();
    // tslint:disable-next-line: forin
    for (const key in whiteList) {
      whiteList[key].push('class');
    }
    whiteList['marquee'] = ['direction'];
    whiteList.span.push('style');
    whiteList.img.push('data-youtube');
    whiteList.video.push('muted');
    whiteList.div.push('style', 'id');
    whiteList.i = ['class'];
    whiteList.a.push('data-friser', 'data-hairstore');
    const myxss = new XSS.FilterXSS({
      whiteList,
      css: {
        whiteList: {
          color: true,
          'background-color': true,
          'font-size': true,
          'font-family': true,
          'line-height': true,
        },
      },
    });
    const html = myxss.process(value);
    return html;
  }

  html2json(val) {
    return JSON.stringify(html2json(this.getSafeValue(val)));
  }

  jsonToHtml(val) {
    if (val) {
      const json = JSON.parse(val);
      const html = json2html(json);
      return this.getSafeValue(html);
    }
  }
}
